// Module
var code = " <gb-edit-base-widget widget=\"$ctrl.widget\" exclude-fields=\"$ctrl.excludeFields\"></gb-edit-base-widget> ";
// Exports
export default code;